import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 8px;
  display: flex;
  flex-direction: column;
`;
export const Header = styled.header`
  background-color: #fff;
  padding: 10px;
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;
export const ActionPanel = styled.div`
  display: flex;
`;
export const SummaryPanel = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: start;
`;
